<template>
    <ModalFormCard :action="'/actions/crm-refill-auto-payment/' + this.subscription.id" class="modal-default">
        <template #title>{{ editingModel.crm_auto_refill_amount ? 'Update' : 'Add' }} refill plan</template>

        <template #default="{ saving, errors }">
            <p class="text-14">
                You can {{ editingModel.crm_auto_refill_amount ? 'update your' : 'add a' }} refill plan below. Learn more about refill plans
                and automatic refills

                <a
                    class="link-text text-purple-600"
                    href="https://support.zapo.com/en/articles/182786-add-a-refill-plan-to-automatically-top-up-your-zapo-crm-balance"
                    target="_blank"
                    >here</a
                >
            </p>

            <div class="bg-grey-300 px-6 py-3 mt-4">
                <p class="font-semibold text-15">Good to know</p>
                <p class="text-grey-900 text-14">
                    Balance payments are non refundable and any unused credit will expire 12 months after purchase, in accordance with our
                    terms and conditions.
                </p>
            </div>

            <Select
                placeholder="Select amount"
                label="Refill plan"
                class="mt-6"
                :options="amounts"
                v-model:value="value.amount"
                :disabled="saving"
                name="amount"
            />

            <p class="text-12 mt-1" v-if="value.amount != null">
                When your balance falls below £10 we will automatically top up your account with {{ $help.dp(value.amount, 0) }} credit.
            </p>

            <Select
                v-if="lCards"
                class="mt-4"
                v-model:value="value.card_id"
                :disabled="saving"
                :options="lCards"
                label="Payment method"
                menuClass="!bg-grey"
                menuMaxHeight="80px"
                name="card_id"
                placeholder="Select a card"
                selectClass="!bg-grey text-15"
                selectedCSS=""
                valueKey="id"
            >
                <template #label-right>
                    <button class="link-text text-purple-600 text-13" type="button" @click="addNew()">Add new card</button>
                </template>

                <template #option="{ option, selected }">
                    <div class="flex items-center w-full" v-if="option.html != 'Add new card'">
                        <PaymentMethodTable :paymentMethod="option" :table="false" :disabled="saving" />

                        <div class="flex items-center ml-4" v-if="option.default_payment_method != null">
                            <IconTrue class="stroke-white w-5 h-5 bg-black rounded-full" />

                            <p class="text-15 pl-2">Default</p>
                        </div>
                    </div>

                    <p v-else>{{ option.html }}</p>
                </template>
            </Select>

            <div class="modal-buttons">
                <ButtonSaving :disabled="saving" class="button-black h-12 default !text-13">{{ editingModel.crm_auto_refill_amount ? 'Update' : 'Add' }} refill plan</ButtonSaving>

                <button class="button-purple default" type="button" v-if='editingModel.crm_auto_refill_amount' @click="showRemove">Remove refill plan</button>
                <button class="button-purple default" type="button" v-else @click="$emit('close')">Close</button>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],

    async created() {
        if (this.options.cards == undefined || this.options.currentValue != null) {
            this.lCards = await this.$axios.get('/actions/user-get-cards')
            // this.lCards.push({ html: 'Add new card', id: 'add' })
        } else {
            this.lCards = this.options.cards
        }

        if (this.options.currentValue != null) {
            this.value = this.options.currentValue
        }

        this.value.card_id =
            this.subscription.stripe_payment_method_id != null
                ? this.lCards.find((c) => c.stripe_card_id == this.subscription.stripe_payment_method_id).id
                : this.lCards.find((c) => c.default_payment_method != null).id
    },

    data() {
        return {
            lCards: null,
            amounts: [
                { value: 10, html: this.$help.dp(10) },
                { value: 25, html: this.$help.dp(25) },
                { value: 50, html: this.$help.dp(50) },
                { value: 75, html: this.$help.dp(75) },
                { value: 100, html: this.$help.dp(100) },
                { value: 250, html: this.$help.dp(250) },
                { value: 500, html: this.$help.dp(500) },
            ],
            value: {
                card_id: this.editingModel.crm_auto_refill_card_id,
                amount: this.editingModel.crm_auto_refill_amount,
            },
        }
    },

    methods: {
        showRemove() {
            this.$event.$emit('modal-open', {
                view: 'CrmAutoRefillRemove',
                editingModel: this.editingModel,
            })
        },

        addNew() {
            this.$event.$emit('modal-open', {
                view: 'PaymentMethodCreate',
                lastModal: {
                    view: 'CrmAutoRefill',
                    editingModel: this.editingModel,
                    options: { ...this.options, currentValue: this.value },
                },
            })
        },
    },

    computed: {
        subscription() {
            return this.editingModel
        },
    },
}
</script>
